
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bOc3m", function(module, exports) {

$parcel$export(module.exports, "EndOfTrialMessageSharedGlobalComponent", () => $e9eafc330cc6dd37$export$d575643e40b02bf0);

var $6orpj = parcelRequire("6orpj");

var $5uXOq = parcelRequire("5uXOq");

var $SzDmm = parcelRequire("SzDmm");
var $b77vc = parcelRequire("b77vc");
var $pyK8a = parcelRequire("pyK8a");

var $8Uumt = parcelRequire("8Uumt");

var $2vSU6 = parcelRequire("2vSU6");

var $3lmGj = parcelRequire("3lmGj");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $gJdig = parcelRequire("gJdig");

var $lpwtK = parcelRequire("lpwtK");

var $aIlMT = parcelRequire("aIlMT");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");

var $dNORD = parcelRequire("dNORD");

var $h07C2 = parcelRequire("h07C2");
const $e9eafc330cc6dd37$export$e4cfe87fe34415bd = (environment, variables)=>(0, $8Uumt.fetchQuery)(environment, (0, $6orpj.default), variables).toPromise().then((data)=>{
        const tenantContexts = data?.tenantContexts || [];
        const entitlement = tenantContexts[0]?.entitlementInfo?.entitlement;
        const ccpTrialLength = entitlement?.offering?.trial?.lengthDays;
        const preDunningEndTimestamp = entitlement?.preDunning?.firstPreDunningEndTimestampV2;
        if (!ccpTrialLength || !preDunningEndTimestamp) return null;
        const trialEndTimestamp = (0, $b77vc.default)((0, $pyK8a.default)(new Date(preDunningEndTimestamp), 14));
        const trialStartTimestamp = (0, $b77vc.default)((0, $pyK8a.default)(new Date(trialEndTimestamp), ccpTrialLength));
        const hasPaymentDetails = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable || false;
        return {
            preDunningEndTimestamp: preDunningEndTimestamp,
            trialEndTimestamp: trialEndTimestamp,
            trialStartTimestamp: trialStartTimestamp,
            hasPaymentDetails: hasPaymentDetails
        };
    });
const $e9eafc330cc6dd37$var$EndOfTrialMessageSharedGlobalComponentImpl = ({ supportedEotmProjectType: supportedEotmProjectType })=>{
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $gJdig.ModalContext));
    const productKey = (0, $2vSU6.projectTypeToCanonicalId)(supportedEotmProjectType);
    const entitlementDetails = productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    const edition = (0, $ldyPw.getEditionForProject)(supportedEotmProjectType, appEditions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: { load: load } } = (0, $4mO32.useEntryPoint)((0, $aIlMT.editionAwarenessTrialModalEntryPoint), {
        cloudId: cloudId,
        productKey: productKey,
        jiraProjectType: (0, $2vSU6.convertToJiraProjectType)(supportedEotmProjectType),
        jiraApplicationKey: (0, $efvDm.getApplicationKeyForProject)(supportedEotmProjectType)
    });
    const hasFetchedMessageData = (0, $5uXOq.useRef)(false);
    const { cohort: cohort, fireStatsigExperimentExposure: fireStatsigExperimentExposure, flagKey: flagKey } = (0, $h07C2.getEndOfTrialMessageExperiment)(supportedEotmProjectType);
    const shouldFetchPreDunning = billingSourceSystem === 'CCP' && !entitlementDetails?.trialEndTime && edition !== 'FREE_EDITION' && !(0, $h07C2.hasViewedScreenWithin24Hours)();
    (0, $5uXOq.useEffect)(()=>{
        hasFetchedMessageData.current = false;
    }, [
        shouldFetchPreDunning
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const fetchPreDunningAndShowModal = async ()=>{
            // ensure message data is only fetched once as load is new object on each render
            if (!shouldFetchPreDunning || hasFetchedMessageData.current) return;
            hasFetchedMessageData.current = true;
            const endOfTrialMessageData = await $e9eafc330cc6dd37$export$e4cfe87fe34415bd(relayEnvironment, {
                cloudId: cloudId,
                hamsProductKey: productKey
            });
            if (!endOfTrialMessageData) return;
            // Do not show the modal to users with payment details
            if (endOfTrialMessageData.hasPaymentDetails) return;
            const preDunningDaysLeft = (0, $SzDmm.default)(new Date(endOfTrialMessageData.preDunningEndTimestamp), new Date());
            if (preDunningDaysLeft < 0 || preDunningDaysLeft > 13) return;
            (0, $h07C2.updateLastViewedDate)();
            fireStatsigExperimentExposure();
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'endOfTrialMessaging', {
                flagKey: flagKey,
                entitlementDetails: entitlementDetails,
                cohort: cohort,
                growthInitiative: 'transmuters',
                projectType: supportedEotmProjectType,
                edition: edition
            });
            if (cohort !== 'variation') return;
            load();
            openModal(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    id: "endOfTrialMessageModalContainer",
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNORD.ModalSkeleton), {
                        onClose: onClose
                    }),
                    runtimeProps: {
                        onClose: onClose,
                        projectType: supportedEotmProjectType,
                        edition: edition,
                        endOfTrialMessageData: endOfTrialMessageData,
                        shouldCloseOnOverlayClick: false
                    }
                }));
        };
        fetchPreDunningAndShowModal();
    }, [
        cloudId,
        cohort,
        createAnalyticsEvent,
        edition,
        entryPointReferenceSubject,
        fireStatsigExperimentExposure,
        load,
        openModal,
        productKey,
        supportedEotmProjectType,
        relayEnvironment,
        shouldFetchPreDunning,
        flagKey,
        entitlementDetails
    ]);
    return null;
};
const $e9eafc330cc6dd37$export$d575643e40b02bf0 = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    if (!(0, $3lmGj.isSupportedEotmProjectType)(projectType)) return null;
    const { isEnrolled: isEnrolled } = (0, $h07C2.getEndOfTrialMessageExperiment)(projectType);
    if (!isEnrolled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9eafc330cc6dd37$var$EndOfTrialMessageSharedGlobalComponentImpl, {
        supportedEotmProjectType: projectType
    });
};

});
parcelRegister("6orpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c0a538b13af199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<757eafa7e4ef3b8fc5e26bfbe4283170>>
 * @relayHash 1d53dc2f7314c80ba663b467e852ec84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5dcb746fda136e84a884ac06831341504198387937fc6b01a81f36ee305b438
const $54c0a538b13af199$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inPreDunning": true
                    }
                ]
            }
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CcpOfferingTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lengthDays"
                    }
                ]
            }
        ],
        "type": "CcpOffering"
    }, v5 = {
        "kind": "ScalarField",
        "name": "firstPreDunningEndTimestampV2"
    }, v6 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v9 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5dcb746fda136e84a884ac06831341504198387937fc6b01a81f36ee305b438",
            "metadata": {},
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$54c0a538b13af199$var$node.hash = "ecb414629484f8d10335358818e21bd3";
var $54c0a538b13af199$export$2e2bcd8739ae039 = $54c0a538b13af199$var$node;

});

parcelRegister("3lmGj", function(module, exports) {

$parcel$export(module.exports, "isSupportedEotmProjectType", () => $bbfabfdd0055e6a3$export$177b0b5ff46e69ac);

var $2vSU6 = parcelRequire("2vSU6");
const $bbfabfdd0055e6a3$var$SUPPORTED_EOTM_PROJECT_TYPES = [
    (0, $2vSU6.SERVICE_DESK_PROJECT),
    (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)
];
const $bbfabfdd0055e6a3$export$177b0b5ff46e69ac = (value)=>{
    const projectType = (0, $2vSU6.toProjectType)(value);
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !!projectType && $bbfabfdd0055e6a3$var$SUPPORTED_EOTM_PROJECT_TYPES.includes(projectType));
};

});

parcelRegister("dNORD", function(module, exports) {

$parcel$export(module.exports, "ModalSkeleton", () => $9ea2d38dcd3eccf0$export$ba38383f4d71feb1);

var $5uXOq = parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $bEIgH = parcelRequire("bEIgH");

var $7NYq5 = parcelRequire("7NYq5");
const $9ea2d38dcd3eccf0$export$ba38383f4d71feb1 = ({ onClose: onClose, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: onClose,
        width: 968,
        height: 576,
        messageId: "end-of-trial-message-shared-global-component.ui.modal.jira-modal",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null));

});

parcelRegister("h07C2", function(module, exports) {

$parcel$export(module.exports, "hasViewedScreenWithin24Hours", () => $63b65b2214aacc81$export$9f0638dc164edb39);
$parcel$export(module.exports, "updateLastViewedDate", () => $63b65b2214aacc81$export$477706b0f3f7e086);
$parcel$export(module.exports, "getEndOfTrialMessageExperiment", () => $63b65b2214aacc81$export$cc0a7ba2b7691053);

var $8Rkzz = parcelRequire("8Rkzz");

var $3lmGj = parcelRequire("3lmGj");

var $6s1PB = parcelRequire("6s1PB");

var $bSSG7 = parcelRequire("bSSG7");

var $bZB1h = parcelRequire("bZB1h");
const $63b65b2214aacc81$var$eotmLocalStorage = (0, $bSSG7.createLocalStorageProvider)('end-of-trial-message');
const $63b65b2214aacc81$export$9f0638dc164edb39 = ()=>{
    const lastViewed = $63b65b2214aacc81$var$eotmLocalStorage.get('lastViewedEOTMDate');
    if (!lastViewed) return false;
    const lastViewedDate = new Date(lastViewed);
    const now = new Date();
    return now.getTime() - lastViewedDate.getTime() < (0, $bZB1h.ONE_DAY_IN_MILLISECONDS);
};
const $63b65b2214aacc81$export$477706b0f3f7e086 = ()=>{
    $63b65b2214aacc81$var$eotmLocalStorage.set('lastViewedEOTMDate', new Date().toISOString());
};
const $63b65b2214aacc81$export$cc0a7ba2b7691053 = (projectType)=>{
    if (!(0, $3lmGj.isSupportedEotmProjectType)(projectType)) return {
        isEnrolled: false,
        cohort: 'not-enrolled',
        fireStatsigExperimentExposure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('end_of_trial_messaging_v2');
    const cohort = endOfTrialMessageConfig.get('cohort', 'not-enrolled');
    return {
        isEnrolled: cohort !== 'not-enrolled',
        cohort: cohort,
        fireStatsigExperimentExposure: fireStatsigExperimentExposure,
        flagKey: 'end_of_trial_messaging_v2'
    };
};

});



//# sourceMappingURL=async-end-of-trial-message-shared.d66657e7.js.map
